import Vue from 'vue'
import Vuex from 'vuex'
// import request from '@/utils/request';
// import config from './modules/config'
// import userMan from './modules/userMan'
// import sensitiveWord from './modules/sensitiveWord'
// import serviceClassifyType from './modules/serviceClassifyType'

Vue.use(Vuex)

// https://webpack.js.org/guides/dependency-management/#requirecontext
const modulesFiles = require.context('./modules', true, /\.js$/)

// you do not need `import app from './modules/app'`
// it will auto require all vuex module from modules file
const modules = modulesFiles.keys().reduce((modules, modulePath) => {
  // set './app.js' => 'app'
  const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1')
  const value = modulesFiles(modulePath)
  modules[moduleName] = value.default
  return modules
}, {})

const store = new Vuex.Store({
    modules,
  })

export default store

// export default new Vuex.Store({
//   state: {
//     userInfo: null,
//   },
//   mutations: {
//     SET_userInfo(state, result) {
//       const st = state;
//       st.userInfo = result;
//     },
//   },
//   actions: {
//     // 获取登录用户
//     findLoginUser({ state }) {
//       return request({
//         url: '/webApi/init/loginUser/findLoginUser',
//         method: 'get',
//         baseURL: state.config.config.XG_MAIN_HOST,
//       }).then((res) => {
//         // 登录失败
//         if (res.data.status === 9000) {
//           window.location.href = window.location.origin;
//         }
//         return Promise.resolve(res);
//       });
//     },
//   },
//   modules: {
//     config,
//     userMan,
//     sensitiveWord,
//     serviceClassifyType
//   }
// })
